import { render } from "./CardPrimary.vue?vue&type=template&id=7572fc9b"
import script from "./CardPrimary.vue?vue&type=script&lang=js"
export * from "./CardPrimary.vue?vue&type=script&lang=js"

import "./CardPrimary.vue?vue&type=style&index=0&id=7572fc9b&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__